/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_VoteInputs */

const en_us2_board_vote = /** @type {(inputs: Board_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const pt_br2_board_vote = /** @type {(inputs: Board_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoiar`)
};

const pt_pt2_board_vote = /** @type {(inputs: Board_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoiar`)
};

/** @type {(inputs: Board_VoteInputs) => LocalizedString} */
const es_419_board_vote = en_us2_board_vote;

/** @type {(inputs: Board_VoteInputs) => LocalizedString} */
const fr_fr2_board_vote = en_us2_board_vote;

/** @type {(inputs: Board_VoteInputs) => LocalizedString} */
const de_de2_board_vote = en_us2_board_vote;

/** @type {(inputs: Board_VoteInputs) => LocalizedString} */
const it_it2_board_vote = en_us2_board_vote;

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Board_VoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_vote = /** @type {((inputs?: Board_VoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_VoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_vote(inputs)
	if (locale === "es-419") return es_419_board_vote(inputs)
	if (locale === "pt-PT") return pt_pt2_board_vote(inputs)
	if (locale === "fr-FR") return fr_fr2_board_vote(inputs)
	if (locale === "de-DE") return de_de2_board_vote(inputs)
	if (locale === "it-IT") return it_it2_board_vote(inputs)
	return en_us2_board_vote(inputs)
});
export { board_vote as "board.vote" }